import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { browserHistory } from 'react-router';
import ConfirmationModal from '../../components/ZUILib/ConfirmationModal';

import commonUtil from '../../utils/commonUtil';

import * as CreateEventActions from './components/createEvent/actions';
import * as CreateEventActionsObj from './actions';

import * as GiftRegistryAddressActions from './components/GiftRegistryAddress/actions';
import * as labelsActions from '../../components/labels/actions';
import * as createAccountActions from '../Accounts/createAccount/actions';
import * as EventCategoryActions from '../../components/eventcategory/actions';

import AppEvents from './../App/AppEvents';

import { createTag } from '../../utils/googleTagManagerUtils';
import * as createEventObject from '../createEvent/actions';
const { strategy } = require('../createEvent/createEventStrategy/strategy');


const pageName = 'weddingCreateEventPage';
const { isLablesLoaded, loadLables } = labelsActions;
const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;
const { isCreateEventDataLoaded, defineCreateEventData } = createEventObject;
const { isGetStateListLoaded, getStateList, getSaveStateData } = CreateEventActions;
const { isGiftRegistryAddressLoaded, loadGiftRegistryAddress } = GiftRegistryAddressActions;
/* const { isContractPageLoaded, loadContractPage } = contractPageActions; */
const channel = commonUtil.getChannel();
const constChannel = commonUtil.getClientConstForChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isLablesLoaded(getState())) {
        return dispatch(loadLables());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isEventCategoryLoaded(getState(), pageName)) {
        return dispatch(loadEventCategoryEvent(pageName, ''));
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isGetStateListLoaded(getState())) {
        return dispatch(getStateList());
      }
      return dispatch(getSaveStateData('weddingCreateEventPage', getState(), 'Initial Load'));
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isGiftRegistryAddressLoaded(getState())) {
        return dispatch(loadGiftRegistryAddress());
      }
      return undefined;
    },
  },
  {
    promise: async ({ store: { dispatch, getState }, location }) => {
      try {
      
        let routeName = (location && location.pathname) || window.location.pathname;
        let eventObj = _.find(_.values(strategy.strategies), { url: routeName });

        if (!eventObj) {
          console.warn("No strategy matched:", routeName);
          return Promise.resolve();
        }

        const globalState = getState();
        
        let eventCategoryData =
          globalState?.eventcategory?.data?.eventConfigurations ||
          await dispatch(loadEventCategoryEvent());
          
        if (eventCategoryData) {
          const eventCategoryObj = _.find(eventCategoryData, {
            name: eventObj.name,
          });
      
          dispatch(
            defineCreateEventData("SelectMesaType", eventCategoryObj?.eventCategory)
          );
          dispatch(
            defineCreateEventData("SelectTypeCelebration", {
              selectEventType: eventObj.name,
              selectedEventConfiguration: eventObj,
            })
          );
        }

        return Promise.resolve();
      } catch (error) {
        console.error("Error in last asyncConnect block:", error);
        return Promise.resolve();
      }
    }
  }
])
@connect(
  store => ({
    lables: store.labels.data,
    error: store.labels.error,
    loading: store.labels.loading,
    extraData: store.labels.extraData,
    eventCategoryType: store.eventcategory.data,
    stateList: store.createEvent.dataState,
    storeList: store.createEvent.dataStore,
    createEventObject: store.createEventObject,
  }),
  { ...labelsActions, ...CreateEventActionsObj, ...createAccountActions,...EventCategoryActions ,...createEventObject}
)
export default class CreateEventStrategyLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
    };
    const { createEventObject = {}, location = {} } = this.props;
    const { query = {} } = location || {};
    const { address = '', addressUpdated = '' } = query || {};

    const { SelectTypeCelebration = {} } = createEventObject || {};
    const { selectedEventConfiguration = null } = SelectTypeCelebration || {};

    this.eventConfiguration = selectedEventConfiguration || {};
    this.eventSteps = this.eventConfiguration.components || [];
    this.addressAddMode = address === 'true' ? 'true' : 'false';
    this.addressUpdateMode = addressUpdated === 'true' ? 'true' : 'false';

    this.currentStep = this.addressAddMode === 'true' || this.addressUpdateMode === 'true' ? 2 : 0;
    this.totalStepsForEvent = this.eventSteps.length || null;
    this.pageName = this.eventConfiguration.name || null;
    this.currentStepComponent = null;

    this.stepBarEvent = null;
    this.wapBackButtonEvent = null;
    this.animationClass = 'createEventAnimationRight';
    this.processing = false;

    this.eventWizardAttributes = {
      nextAttr: {
        value: channel === 'web' ? 'Siguiente paso' : 'Siguiente',
        style: channel === 'web' ? 'btnPrimary size-Large' : 'btnPrimary size-Full',
        id: this.pageName + '_next',
        classname: 'alignRight',
        onClickHandler: this.nextStepFunc,
        // iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      },
      prevAttr: {
        // value: 'Regresar',
        value : 'Atrás',
        style: 'btnSecondaryAction size-Large',
        id: this.pageName + '_prev',
        classname: 'back',
        onClickHandler: this.prevStepFunc,
        // iconClass: 'iconLeft icon-flecha_light_izq',
      },
      submitAttr: {
        value: 'Terminar registro',
        style: channel === 'web' ? 'btnPrimary size-Large' : 'btnPrimary size-Full',
        id: this.pageName + '_submit',
        classname: 'alignRight',
        onClickHandler: this.submitFunc,
      },
    };
  }

  UNSAFE_componentWillMount = () => {
    /* if (typeof window !== 'undefined') { */
    /*   window.addEventListener('beforeunload', commonUtil.browserRefresh); */
    /* } */
    if (this.props.createEventObject.SelectTypeCelebration === undefined && browserHistory) {
      // browserHistory.push(applicationRoutes.mesaType);
    }
    if (channel === constChannel.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED_GR);
    }
    this.stepBarEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.CREATE_EVENT_STEP_BAR);
    this.logoClickEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.CREATE_EVENT_LOGO_CLICK);
  };

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('beforeunload', this.redirectToHome);
    }
    if (channel === constChannel.WAP) {
      AppEvents.unsubscribe(this.wapBackButtonEvent);
    }
    AppEvents.unsubscribe(this.stepBarEvent);
  }

  componentDidMount() {
  const { createEventObject,defineCreateEventData,loadEventCategoryEvent } = this.props;

  if (!createEventObject.SelectTypeCelebration) {
    const routeName = this.props.location?.pathname || window.location.pathname;
    const eventObj = _.find(_.values(strategy.strategies), { url: routeName });

    if (eventObj) {
      loadEventCategoryEvent().then((res) => {
        const eventCategoryObj = _.find(
          res?.eventConfigurations,
          { name: eventObj.name }
        );

        if (eventCategoryObj) {
          defineCreateEventData("SelectMesaType", eventCategoryObj.eventCategory);
          defineCreateEventData("SelectTypeCelebration", {
            selectEventType: eventCategoryObj.name,
            selectedEventConfiguration: eventObj,
          });
        }
      });
    }
  }
    if (this.stepBarEvent == null) {
      this.stepBarEvent = AppEvents.subscribe(
        AppEvents.EVENT_REGISTER.CREATE_EVENT_STEP_BAR
      );
    }
    AppEvents.publish(this.wapBackButtonEvent, [this.prevStepFunc]);
    AppEvents.publish(this.logoClickEvent, [this.removeRouteLeaveHook]);
    document.querySelectorAll('.giftBreadcrumbs a').forEach(item =>
      item.addEventListener('click', (_item) => {
        _item.preventDefault();
        this.modal.open(_item.target.pathname);
      }),
    );

    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', this.redirectToHome);
    }
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
  }

  redirectToHome = () => {
    window.location.href = applicationRoutes.home;
  }

  routerWillLeave = () => {
    if (this.currentStep > 0) {
      this.prevStepFunc();
    } else {
      return commonUtil.getLabel(
        this.props.lables.createEventStep1,
        'createEventStep1.quitCreatingEvent.browserback.message',
      );
    }
    return false;
  };

  nextStepFunc = (e) => {
    const onInputEventDataStep = this.currentStep === 1;

    if (!this.processing) {
      if (onInputEventDataStep) {
        const eventHasPhoto = !_.isEmpty(this.step.formData.createEvent.imageURL);

        createTag({
          event: 'mesa_regalos',
          phase: 'Crear mesa de regalos',
          step: 'Datos del evento',
          selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,
          seccion: 'Mesa de Regalos',
          foto: eventHasPhoto ? 'Si' : 'No',
        });
      }

      this.processing = true;
      e.preventDefault();
      const { _fetchProfileEventsInfo } = this.props;
      _fetchProfileEventsInfo().then((response) => {
        this.processing = false;
        if (response && response.status && response.status.status === 'success') {
          this.step.validate(this.nextCallBack);
        } else {
          browserHistory.push(applicationRoutes.createAccount);
        }
      });
    }
  }

  cancelFunc = (e) => {
    e.preventDefault();
    const { clearEventData } = this.props;
    clearEventData();
  }

  nextCallBack = (formValid) => {
    if (formValid) {
      this.currentStep += 1;
      this.animationClass = 'createEventAnimationRight';
      this.setState({ currentStep: this.currentStep });
    } else {
      return false;
    }
    return true;
  }

  prevStepFunc = (e) => {
    const { createEventObject = {} } = this.props;
    const { SelectTypeCelebration = {} } = createEventObject || {};
    const { selectedEventConfiguration = {} } = SelectTypeCelebration || {};
    const { eventType = '' } = selectedEventConfiguration || {};

    if (e) {
      e.preventDefault();
    }

    const onInputCelebratedDataStep = this.currentStep === 0;
    const onInputEventDataStep = this.currentStep === 1;
    const onSelectAddressStep = this.currentStep === 2;
    const onAcceptContractStep = this.currentStep === 3;

    const { _fetchProfileEventsInfo } = this.props;
    _fetchProfileEventsInfo().then((response) => {
      if (response.status.status === 'success') {
        if (this.currentStep > 0) {
          if (onInputEventDataStep) {
            createTag({
              event: 'mesa_regalos',
              seccion: 'Mesa de Regalos',
              phase: 'Crear mesa de regalos',
              step: 'Atras datos del evento',
            });
          } else if (onSelectAddressStep) {
            createTag({
              event: 'mesa_regalos',
              seccion: 'Mesa de Regalos',
              phase: 'Crear mesa de regalos',
              step: 'Atras direccion del evento',
            });
          } else if (onAcceptContractStep) {
            createTag({
              event: 'mesa_regalos',
              seccion: 'Mesa de Regalos',
              phase: 'Crear mesa de regalos',
              step: 'Atras terminar registro',
            });
          }

          this.currentStep -= 1;
          this.currentStepComponent = null;
          this.animationClass = 'createEventAnimationLeft';
          this.setState({ currentStep: this.currentStep });
        } else if (onInputCelebratedDataStep) {
          createTag({
            event: 'mesa_regalos',
            seccion: 'Mesa de Regalos',
            phase: 'Crear mesa de regalos',
            step: 'Atras datos del festejado',
          });
          const createAcceptOrCancelBackTag = (accepted) => {
            createTag({
              event: 'mesa_regalos',
              seccion: 'Mesa de Regalos',
              phase: 'Crear mesa de regalos',
              step: `Atras ${accepted ? 'aceptar' : 'cancelar'} datos del festejado`,
            });
          };
          let pageRoute = '';
          this.props.router.setRouteLeaveHook(this.props.route, '');

          if (eventType === 'Celebraciones') {
            pageRoute = applicationRoutes.celebrationType;
            this.modal.open(pageRoute).then(createAcceptOrCancelBackTag);
          } else if (
            channel === 'wap' &&
            window &&
            window.location &&
            window.location.pathname &&
            (applicationRoutes.celebrationType === window.location.pathname ||
              applicationRoutes.openType === window.location.pathname)
          ) {
            browserHistory.push(applicationRoutes.mesaType);
          } else {
            pageRoute = applicationRoutes.openType;
            this.modal.open(pageRoute).then(createAcceptOrCancelBackTag);
          }
        } else {
          browserHistory.push(applicationRoutes.mesaType);
        }
      } else if (response.status.status === 'failure') {
        browserHistory.push(applicationRoutes.createAccount);
      }
    });
  }

  submitFunc = () => {
    if (this.currentStep === 3) {
      this.props.router.setRouteLeaveHook(this.props.route, '');
    }
    if (this.step.validate()) {
      // return browserHistory.push('/eventManagement/GiftList');
    }
    return false;
  }

  updateGRHeaderProps = (totalSteps) => {
    if (this.stepBarEvent) {
      AppEvents.publish(this.stepBarEvent, [{ currentStep: this.currentStep + 1, total: this.totalStepsForEvent || totalSteps }]);
    }
  };

  removeRouteLeaveHook = () => {
    this.props.router.setRouteLeaveHook(this.props.route, '');
  };

  render() {
    const { lables, createEventObject } = this.props;
    const { SelectTypeCelebration = {} } = createEventObject || {};
    const { selectedEventConfiguration = null } = SelectTypeCelebration || {};

    this.eventConfiguration = selectedEventConfiguration || {};
    this.eventSteps = this.eventConfiguration.components || [];
    const quitMessage = commonUtil.getLabel(
      lables.createEventStep1,
      "createEventStep1.quitCreatingEvent.message"
    );
    
    this.currentStepComponent =
      this.eventSteps && this.eventSteps.length > 0
        ? this.eventSteps[this.currentStep].component({
          onReference: reference => (this.step = reference),
            eventWizardAttributes: this.eventWizardAttributes,
            currentStep: this.currentStep,
            totalStepsForEvent: this.totalStepsForEvent,
            animationClass: this.animationClass,
            removeRouteLeaveHook: this.removeRouteLeaveHook,
          })
        : null;

    let WAPCss = '';
    if (this.currentStep === 2) {
      WAPCss = 'grayBackground';
    } else if (this.currentStep === 0) {
      WAPCss = 'row';
    } else {
      WAPCss = '';
    }
    this.updateGRHeaderProps(this.eventSteps.length);

    return (
      <React.Fragment>
        <div className={channel === constChannel.WEB ? 'row' : WAPCss}>
          <div id="giftRegistry" className="stepComponentContainer">
            {this.currentStepComponent}
          </div>
          <ConfirmationModal
            id="createEventQuitModal"
            ref={modal => (this.modal = modal)}
            cancelClick={this.cancelFunc}
            removeRouteLeaveHook={this.removeRouteLeaveHook}
            message={quitMessage}
            acceptClick={this.resetCurrentStep}
          />
        </div>
      </React.Fragment>
    );
  }
}
